import './Feedback.css';

/**
 * Corner spinner shown while a modal's primary action ("Create"/"Change"/"Save"/
 * "Apply"/"Delete") is in flight.
 *
 * The buttons themselves already go `disabled` for the duration, which stops the
 * double-click but says nothing about why -- this is the matching feedback for
 * that dead moment, so the modal doesn't just sit there looking frozen.
 *
 * Deliberately shares its look and position with <SavingIndicator /> (see
 * Feedback.css): same pill, same corner, same fade. Distinct from <Loading />,
 * which is the full-page/inline spinner for a view that has nothing to show yet.
 *
 * The root class is `mc-loading-indicator`, NOT `mc-loading` -- that one already
 * belongs to <Loading />.
 *
 * @param {boolean} active  true while the request is running.
 * @param {string}  label   e.g. t('common.loading').
 */
function LoadingIndicator({ active = false, label = '' }) {
    return (
        <div
            className={`mc-loading-indicator${active ? ' show' : ''}`}
            role="status"
            aria-live="polite"
            aria-hidden={!active}
        >
            <span className="mc-loading-indicator-spinner" aria-hidden="true" />
            <span className="mc-loading-indicator-label">{label}</span>
        </div>
    );
}

export default LoadingIndicator;
